import React, { useEffect, useState } from "react";
import AdminNav from "../../navigation/AdminNav";
import { Grid, CircularProgress, Button } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import { getProjects, deleteProject, updateProject } from '../../actions/projects';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * This page presents the admin with a form to fill out to allow them to edit existing projects that were submitted by the students.
 * When the project is submitted it will automatically show up on the screen which lets them know it submitted properly and be sent to the 
 * student projects collection in the database.
 * @returns the project edit form along with a list of the projects that was created by all the different lecturers.
 */

function AdminManageStudents() {

    const [postProject, setPostProject] = useState({
        title: '', supervisor: '', description: ''
    });

    const [id, setID] = useState(null)

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getProjects());
    }, [dispatch, postProject]);
    
    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateProject(id, postProject));
            alert("Project Edited")
        }
        clearFields();
    }

    const handleProjectEdit = (project) => {
        const newProject = Object.assign({}, postProject)

        newProject.title = project.title;
        newProject.supervisor = project.supervisor;
        newProject.description = project.description;

        setID(project._id)
        setPostProject(newProject);
    }

    const clearFields = () => {
        setID(null);
        setPostProject({title: '', supervisor: '', description: ''});
    }

    let projects = []
    const response = useSelector((state) => state.projects.data);
    if (response){
        projects = Array.from(response);
    }

    return(
        <div>
            <AdminNav />
            <form id={id} onSubmit={submitHandler}>
                <h1>Manage Student Project Database</h1>
                <p>Below are all of the student recommended projects</p>
                <label>
                    Project Name: 
                    <input type="text" name="title" label="Name" value={postProject ? postProject.title : ''} onChange={(e) => setPostProject({...postProject, title: e.target.value})}></input>
                </label>
                <label>
                    Agreed Supervisor: 
                    <input type="text" name="supervisor" label="Supervisor" value={postProject ? postProject.supervisor : ''} onChange={(e) => setPostProject({...postProject, supervisor: e.target.value})}></input>
                </label>
                <label>
                    Project Description: 
                    <input type="text" name="description" label="Description" value={postProject ? postProject.description : ''} onChange={(e) => setPostProject({...postProject, description: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateProject(id, postProject)}></input>
                <Button onClick={clearFields}>
                    <ClearIcon/>
                    Clear
                </Button>
            </form>
            {!projects.length ? <CircularProgress /> : (
                <Grid>
                    {projects.map((project) => (
                        <Grid className="paper" key={project._id} item>
                            <p>{project.title}</p>
                            <p>{project.supervisor}</p>
                            <p>{project.description}</p>
                            <Button onClick={() => handleProjectEdit(project)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            <Button onClick={() => dispatch(deleteProject(project._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default AdminManageStudents